// removed by extract-text-webpack-plugin
module.exports = {"card":"src-components-Card----styles-module---card---1vc51","cardImage":"src-components-Card----styles-module---cardImage---36KLo","link":"src-components-Card----styles-module---link---2rCAm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/styles.module.css
// module id = 194
// module chunks = 35783957827783 275574534170046